import type { ReactNode } from "react";

import { ClickableCellWrapper } from "app/pages/sales-intelligence/common-components/table-cells";
import type { OverviewWidgetId } from "app/pages/sales-intelligence/modules/extension-management/types";
import { useLeadCellActions } from "app/pages/sales-intelligence/modules/leads-search/hooks/cells/useLeadCellActions";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search/types";

interface ICrmCellRightBarLogicProps {
    record: LeadsSearchRow;
    widgetId: OverviewWidgetId;
    children: ReactNode;
}

export const CrmCellRightBarLogicContainer = ({ record, widgetId, children }: ICrmCellRightBarLogicProps) => {
    const { onToggleSidebar: handleToggleRightSidebar } = useLeadCellActions({ record, widgetId });

    return (
        <ClickableCellWrapper
            onClick={handleToggleRightSidebar}
            centered
        >
            {children}
        </ClickableCellWrapper>
    );
};
